import { SchemaProperty } from '@amzn/awscat-portfolio-assessment-types';
import { Button, SelectProps, SpaceBetween } from '@amzn/awsui-components-react';
import * as React from 'react';

import { constants } from '../../../common/Localization';
import AddAttributeModal from './AddAttributeModal';
import DeleteAttributeModal from './DeleteAttributeModal';

interface AttributeActionGroupProps {
    loading: boolean;
    existingSchemas: SchemaProperty[];
    onConfirmAddAttribute: (attrName: string, attrType: string, dataType: string) => Promise<void>;
    onConfirmDeleteAttribute: (attributeName?: string) => Promise<void>;
}

const AttributeActionGroup = (props: AttributeActionGroupProps):JSX.Element => {
    const [addAttributeModalVisible, setAddAttributeModalVisible] = React.useState(false);
    const [deleteAttributeModalVisible, setDeleteAttributeModalVisible] = React.useState(false);

    const existingAttributes: string[] = props.existingSchemas.map(schema => schema.value);
    const deleteAttributeOptions: SelectProps.Options = props.existingSchemas.filter(schema => schema.mutable).map(schema => {
        return {
            label: schema.text,
            value: schema.value,
        };
    });

    const addAttributeOnClick = (): void => {
        setAddAttributeModalVisible(true);
    };
    
    const deleteAttributeOnClick = (): void => {
        setDeleteAttributeModalVisible(true);
    };

    return (
        <SpaceBetween direction="horizontal" size="xs">
            <Button disabled={props.loading || deleteAttributeOptions.length === 0} onClick={deleteAttributeOnClick}>
                {constants.DELETE_ATTRIBUTE_BUTTON_TEXT}
            </Button>
            <Button disabled={props.loading} onClick={addAttributeOnClick}>{constants.ADD_ATTRIBUTE_BUTTON_TEXT}</Button>
            <AddAttributeModal
                visible={addAttributeModalVisible}
                setVisible={setAddAttributeModalVisible}
                existingAttributes={existingAttributes}
                onConfirmAddAttribute={props.onConfirmAddAttribute}
            />
            <DeleteAttributeModal
                visible={deleteAttributeModalVisible}
                setVisible={setDeleteAttributeModalVisible}
                deleteAttributeOptions={deleteAttributeOptions}
                onConfirmDeleteAttribute={props.onConfirmDeleteAttribute}
            />
        </SpaceBetween>
    );
};

export default AttributeActionGroup;
